import { format } from 'date-fns-tz';
import { useMemo } from 'react';
import { DefaultFilters } from '../../../../../services/modules/userContextPreferences/userContextPreferences.types';
import { DateShortcut } from '../../../../FilterV3/components/DateRangeFilterV2/dateRangeFilter.types';
import { getDateShortcuts } from '../../../../FilterV3/components/DateRangeFilterV2/dateShortcuts';

interface UseDateRangeDefaultFilterParams {
  startDateKey: string;
  endDateKey: string;
  shortcutKey: string;
  shortcutStepKey: string;
  defaultFilters: DefaultFilters | null;
  systemDefaultShortcut?: DateShortcut;
}
const useDateRangeDefaultFilter = ({
  endDateKey,
  startDateKey,
  defaultFilters,
  shortcutKey,
  shortcutStepKey,
  systemDefaultShortcut = DateShortcut.NINETY_DAYS,
}: UseDateRangeDefaultFilterParams) => {
  const {
    initialDateDefaultValue,
    finalDateDefaultValue,
    shortcutDefaultValue,
    shortcutStepDefaultValue,
  } = useMemo(() => {
    const defaultDate = getDateShortcuts().find((date) => date.name === systemDefaultShortcut);

    const PATTERN = 'yyyy-MM-dd';

    const systemInitialDate = defaultDate?.initialDate
      ? format(defaultDate.initialDate, PATTERN)
      : undefined;
    const systemFinalDate = defaultDate?.finalDate
      ? format(defaultDate.finalDate, PATTERN)
      : undefined;

    return {
      initialDateDefaultValue: defaultFilters ? defaultFilters?.[startDateKey] : systemInitialDate,
      finalDateDefaultValue: defaultFilters ? defaultFilters?.[endDateKey] : systemFinalDate,
      shortcutDefaultValue: defaultFilters ? defaultFilters[shortcutKey] : systemDefaultShortcut,
      shortcutStepDefaultValue: defaultFilters ? defaultFilters[shortcutStepKey] : undefined,
    };
  }, [
    defaultFilters,
    endDateKey,
    startDateKey,
    shortcutKey,
    shortcutStepKey,
    systemDefaultShortcut,
  ]);

  return {
    initialDateDefaultValue,
    finalDateDefaultValue,
    shortcutDefaultValue,
    shortcutStepDefaultValue,
  };
};

export default useDateRangeDefaultFilter;
